import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken } from "@/utils"; // get token
import { getPageTitle } from "@/utils";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ["/login"]; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start();

  // set page title
  document.title = getPageTitle(to.meta.title);

  const hasToken = getToken();

  if (hasToken) {
    if (to.path === "/login") {
      next({ path: "/" });
      NProgress.done();
    } else {
      next();
      let roles = store.getters.roles;
      const hasRoles = roles && roles.length > 0;
      if (hasRoles) {
        const accessRoutes = await store.dispatch("permission/generateRoutes", roles);
        router.addRoutes(accessRoutes);
      } else {
        next(`/login`);
        NProgress.done();
        // try {
        //   const { roles } = await store.dispatch("user/getInfo");
        //   const accessRoutes = await store.dispatch("permission/generateRoutes", roles);
        //   router.addRoutes(accessRoutes);
        //   next({ ...to, replace: true });
        // } catch (error) {
        //   await store.dispatch("user/resetToken");
        //   Message.error(error || "Has Error");
        //   next(`/login?redirect=${to.path}`);
        //   NProgress.done();
        // }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
